var _rect, _circle, _rect2, _path, _rect3, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeZoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Time_Zone",
    "data-name": "Time Zone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1231",
    "data-name": "Rectangle 1231",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(12.62 3.15)",
    fill: "#f9932f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M21.81,5.29a2.784,2.784,0,0,1,.06.58",
    fill: "#165cf3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    width: 30,
    height: 30,
    transform: "translate(1 0.88)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    d: "M11.57,2.64a6.651,6.651,0,0,0-3.02-.71,6.75,6.75,0,0,0,0,13.5H9.86",
    fill: "none",
    stroke: "#f9932f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_760-2",
    d: "M15.3,9.24V8.68a6.793,6.793,0,0,0-.84-3.27",
    fill: "none",
    stroke: "#f9932f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    d: "M8.55,4.69V8.83h3.37",
    fill: "none",
    stroke: "#f9932f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    d: "M19.98,8.21A10.315,10.315,0,1,0,30.2,18.62v-.09h0A10.218,10.218,0,0,0,20.08,8.22h-.09Z",
    fill: "none",
    stroke: "#13dd78",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    d: "M19.98,8.21c-2.91,0-5.53,4.59-5.53,10.31s2.62,10.22,5.53,10.22,5.53-4.59,5.53-10.22S22.79,8.21,19.98,8.21Z",
    fill: "none",
    stroke: "#13dd78",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    d: "M13.14,11.87a12.206,12.206,0,0,0,13.69,0m0,13.22a12.206,12.206,0,0,0-13.69,0",
    fill: "none",
    stroke: "#13dd78",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    d: "M19.98,8.21V28.74M30.2,18.52H9.77",
    fill: "none",
    stroke: "#13dd78",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZoneIcon);
export default __webpack_public_path__ + "static/media/time-zone-icon.914ca57c703ab265d18f4e196b676d09.svg";
export { ForwardRef as ReactComponent };